import { StarsButton } from '@ps/web-shared-components';
import React, { useContext } from 'react';

import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';

import BackArrow from '../../../../../../assets/icons/back-arrow.svg';
import type { Buttons } from '../../Header';
import DocumentTitleHeader from '../DocumentTitleHeader/DocumentTitleHeader';

import { TXTCLI_Back } from './NavigationHeader.messages.json';
import { container, headerSecondary, wrapper } from './NavigationHeader.scss';

interface Props {
  buttons?: Buttons;
  backButtonDisabled: boolean;
  handleBackClick: () => void;
  title: React.ReactNode;
}

const NavigationHeader: React.FC<Props> = ({
  buttons,
  backButtonDisabled,
  handleBackClick,
  title
}) => {
  const { previous } = useContext(NavigationContext);

  return (
    <>
      <DocumentTitleHeader title={title} />
      <div className={container} data-testid="navigation-header">
        <div className={headerSecondary}>
          <div className={wrapper}>
            {(buttons?.back || (!buttons && previous)) && (
              <StarsButton
                icon={<BackArrow />}
                disabled={backButtonDisabled}
                onClick={handleBackClick}
                translation={TXTCLI_Back}
                variant="text"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default NavigationHeader;
